export const PREMIUM_COURSES_MONTHLY_DISCOUNT = '10%';
export const PREMIUM_COURSES_ANNAUL_DISCOUNT = '20%';
